module.exports = __webpack_public_path__ + "static/media/vn.330ca683.svg";